import React from 'react';
import './Terms.css';
import iconBack from '../../assets/images/icon-back.svg';

interface TermsProps {
  onBack: () => void;
}

const Terms: React.FC<TermsProps> = ({ onBack }) => {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <div className="terms-header-wrapper">
          <img src={iconBack} alt="뒤로가기" className="header-icon" onClick={onBack} />
          <h1 className="terms-title">약관</h1>
          <div className="header-icon"></div>
        </div>
      </div>

      <div className="terms-content">
        <h2 className="terms-page-title">약관</h2>
        <section className="terms-section">
          <h2 className="terms-section-title">제1조 (목적)</h2>
          <p className="terms-text">
            본 약관은 삐삐(이하 "회사")가 제공하는 통신 서비스 가격 비교 및 추천 서비스(이하 "서비스")의 이용과 관련하여
            회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제2조 (정의)</h2>
          <p className="terms-text">
            1. "서비스"란 회사가 제공하는 통신 서비스(휴대폰, 인터넷, TV 등) 가격 비교 및 추천 서비스를 의미합니다.
          </p>
          <p className="terms-text">
            2. "회원"이란 본 약관에 동의하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.
          </p>
          <p className="terms-text">
            3. "아이디(ID)"란 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제3조 (약관의 효력 및 변경)</h2>
          <p className="terms-text">
            1. 본 약관은 서비스를 이용하고자 하는 모든 회원에게 그 효력이 발생합니다.
          </p>
          <p className="terms-text">
            2. 회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다.
          </p>
          <p className="terms-text">
            3. 회사가 약관을 변경할 경우 적용일자 및 변경사유를 명시하여 현행약관과 함께 서비스 초기화면에
            그 적용일자 7일 이전부터 적용일자 전날까지 공지합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제4조 (회원가입)</h2>
          <p className="terms-text">
            1. 회원가입은 이용자가 약관의 내용에 동의하고, 회사가 정한 가입양식에 따라 회원정보를 기입한 후
            회원가입 신청을 하여 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
          </p>
          <p className="terms-text">
            2. 회사는 다음 각 호에 해당하는 신청에 대해서는 승낙을 하지 않을 수 있습니다:
            <br />가. 실명이 아니거나 타인의 명의를 이용한 경우
            <br />나. 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
            <br />다. 관련 법령에 위배되거나 사회의 안녕질서 혹은 미풍양속을 저해할 목적으로 신청한 경우
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제5조 (개인정보의 보호)</h2>
          <p className="terms-text">
            회사는 관련 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.
            개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제6조 (회원의 의무)</h2>
          <p className="terms-text">
            1. 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항 등을 준수하여야 합니다.
          </p>
          <p className="terms-text">
            2. 회원은 내용별로 회사가 서비스 공지사항에 게시하거나 별도로 공지한 이용 제한 사항을 준수하여야 합니다.
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제7조 (서비스의 제공)</h2>
          <p className="terms-text">
            1. 회사는 회원에게 아래와 같은 서비스를 제공합니다:
            <br />가. 통신 서비스 가격 비교
            <br />나. 맞춤형 요금제 추천
            <br />다. 상담 서비스
            <br />라. 기타 회사가 정하는 서비스
          </p>
        </section>

        <section className="terms-section">
          <h2 className="terms-section-title">제8조 (서비스의 중단)</h2>
          <p className="terms-text">
            회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는
            서비스의 제공을 일시적으로 중단할 수 있습니다.
          </p>
        </section>

        <div className="terms-footer">
          <p>시행일: 2024년 1월 1일</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
